<template>

  <v-container fluid fill-height pa-0>

    <v-layout column fill-height ma-0 pa-0>

      <v-layout fill-height ma-0 pa-0 >

        <v-flex xs12 >

          <v-layout fill-height column  ma-0 pa-0 >
           
            <scroll-area>
              <template slot="header">

                <v-toolbar  dense flat>
                  <v-toolbar-title>
                    <span class="body-2 uppercase">{{ $t('connections') }}</span>
                  </v-toolbar-title>

                  <v-layout fill-height justify-end align-center>

                    <v-tooltip v-if="edit && !readonly" dark color="secondary" bottom>
                      <v-btn :data-testid="$options.name + 'v-btn' + 'onAdd'" icon flat slot="activator" @click="() => onAdd()">
                        <svg-icon
                          :color="'primary'"
                          :name="'add'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('add') }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="!edit && !readonly" dark color="secondary" bottom>
                      <v-btn :data-testid="$options.name + 'v-btn' + 'edit--edit'" icon flat slot="activator" @click="() => {edit = !edit}">
                        <svg-icon
                          :color="'primary'"
                          :name="'edit'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('edit') }}</span>
                    </v-tooltip>

                    <v-tooltip v-if="edit" dark color="secondary" bottom>
                      <v-btn :data-testid="$options.name + 'v-btn' + 'edit--edit'" icon flat slot="activator"  @click="() => {edit = !edit}">
                        <svg-icon
                          :color="'primary'"
                          :name="'close'"
                          width="20"
                        />
                      </v-btn>
                      <span>{{ $t('close') }}</span>
                    </v-tooltip>

                  </v-layout>

                </v-toolbar>

              </template>

              <template slot="body">

                <v-layout column fill-height justify-start ma-0 pa-0 >

                  <scroll-table
                    :data="getTable"
                    :options="getOptions"
                    :subscribed="true"
                    :headUppercase="false"
                    :translate="true"
                    @select=""
                    @value="(payload)=>onSelect(payload)"
                    @remove=""
                  />

                </v-layout>

              </template>

            </scroll-area>
          </v-layout>

        </v-flex>
        
      </v-layout>

    </v-layout>

    <v-dialog persistent v-model="dialog.open" max-width="1000px" v-if="dialog.open">
      <connection-card
        :data="getDialogData"
        :addMode="getAddMode"
        :parentData="getData"
        :readonly="readonly"
        @update="(payload) => onUpdate(payload)"
        @remove="(payload) => onRemove(payload)"
        @close="() => onDialogClose()"
      />
    </v-dialog>

  </v-container>

</template>

<script lang="ts">
import Vue from 'vue'
import scrollArea from '@/nms/components/partials/scrollarea.vue'
import scrollTable from '@/nms/components/partials/scrolltable.vue'
import ConnectionCard from '@/nms/pages/services/сreate-connection-card.vue'
import svgIcon from '@/nms/components/media/svg/static/svg-icon.vue'

// Типы
interface EndpointRef {
  $id?: string
  $ref_id?: string
  ref?: string
  namePath?: string[]
  [key: string]: any
}

interface ConnectionItem {
  $id?: string
  id?: string
  name?: string
  template?: string
  refs?: EndpointRef[]
  brefs?: Array<{ ref?: string; name?: string; port_type?: string; [key: string]: any }>
  points?: EndpointRef[]
  point_a?: Array<{ path: string; obj: EndpointRef }>
  point_b?: Array<{ path: string; obj: EndpointRef }>
  services?: string[]
  [key: string]: any
}

interface DialogState {
  open: boolean
  addMode: boolean
  data: any | null
}

interface TableColumn {
  title: string
  value: string
  type: string
  width: string
}

interface TableData {
  columns: TableColumn[]
  rows: ConnectionItem[]
}

interface OptionsColumns {
  [key: string]: { width: string }
}

interface OptionsData {
  columns: OptionsColumns
}

interface ConnectionsData {
  $id?: string
  [key: string]: any
}

export default Vue.extend({
  name: 'CONNECTIONS',

  components: {
    scrollArea,
    scrollTable,
    ConnectionCard,
    svgIcon
  },

  props: {
    data: {
      type: Object as () => ConnectionsData,
      default: () => ({})
    },
    readonly: {
      type: Boolean,
      default: () => false
    },
  },

  data(): {
    dialog: DialogState
    edit: boolean
    show: boolean
    groupUse: boolean
    model: Record<string, any>
    connections: ConnectionItem[]
    options: OptionsData
    search: string
    table: TableData
  } {
    return {
      dialog: {
        open: false,
        addMode: false,
        data: null,
      },
      edit: false,
      show: false,
      groupUse: false,
      model: {},
      connections: [],
      options: {
        columns: {
          text: { width: '40%' },
          timestamp: { width: '40%' },
          actions: { width: '40%' },
          check: { width: '20%' },
          check_dependence: { width: '5%' },
        },
      },
      search: '',
      table: {
        columns: [],
        rows: [],
      },
    }
  },

  computed: {
    getData(): ConnectionsData {
      return this.data
    },
    getDialogData(): any | null {
      return this.dialog.data
    },
    getAddMode(): boolean {
      return this.dialog.addMode
    },
    getTable(): TableData {
      const t = this.$merge({}, this.table) as TableData
      if (this.search.length) {
        const searchLower = this.search.toLowerCase()
        t.rows = t.rows.filter(row => {
          return row.name?.toLowerCase().indexOf(searchLower) > -1
        })
        return t
      }
      return this.table
    },
    getOptions(): OptionsData {
      return this.options
    },
  },

  watch: {
    data: {
      handler(): void {
        this.setup('WATCH data')
      },
      deep: true
    },
  },

  created(): void {
    this.setup('created')
  },

  methods: {
    async setup(caller?: string): Promise<void> {
      console.log('CONNECTIONS SETUP caller', caller)
      console.log('CONNECTIONS', 'loadConnections', 'getData', this.getData)
      await this.loadConnections()
      this.statusUnsubscribe()
    },

    async loadConnections(): Promise<void> {
      console.log('CONNECTIONS', 'loadConnections', 'START')
      if (!this.getData.$id) return
      
      try {
        const obj$ = await this.$bridge.getObjectById(this.getData.$id)

        const query = {
          id: [
            {
              fnc: 'getObjectConnections',
              data: { id: obj$.$id }
            }
          ],
          notNull: true,
          namePath: true,
          data: {
            parent: false,
            namePath: true,
            refs: {
              data: { namePath: true, path: true }
            },
            brefs: {
              data: { namePath: true, path: true }
            },
          }
        }
        
        const connections = await this.$bridge.cmdbQuery(query)
        if (connections) {
          console.log('CONNECTIONS', 'loadConnections', 'connections', connections)
          this.connections = connections
        }
        this.prepareColumns()
      } catch (error) {
        console.error('CONNECTIONS', 'loadConnections smth wrong', error)
      }
    },

    async prepareColumns(): Promise<void> {
      this.table = {
        columns: [
          {
            title: 'name',
            value: 'name',
            type: 'text',
            width: '20%'
          },
          {
            title: 'type',
            value: 'template',
            type: 'text',
            width: '10%'
          },
          {
            title: 'point_a',
            value: 'point_a',
            type: 'endpoint_subscrybed',
            width: '20%'
          },
          {
            title: 'point_b',
            value: 'point_b',
            type: 'endpoint_subscrybed',
            width: '20%'
          },
          {
            title: 'services',
            value: 'services',
            type: 'array',
            width: '30%'
          },
        ],
        rows: []
      }
      this.prepareRows()
    },

    async prepareRows(): Promise<void> {
      this.table.rows = this.connections.map(connection => {
        if (connection.refs?.length) {
          connection.points = []
          connection.refs.forEach(ref => {
            if (ref.ref === 'endpoint') {
              connection.points?.push(ref)
            }
          })
          
          if (connection.points?.length) {
            const point = connection.points[0].namePath
            connection.point_a = [{
              path: point?.slice(10) || '',
              obj: connection.points[0]
            }]
            
            if (connection.points[1]) {
              const point = connection.points[1].namePath
              connection.point_b = [{
                path: point?.slice(10) || '',
                obj: connection.points[1]
              }]
            }
            this.statusSubscribe(connection.points, 'CONNECTIONS')
          }
        }

        if (connection.brefs?.length) {
          connection.services = []
          connection.brefs.forEach(bref => {
            if (bref.ref === 'connection') {
              connection.services?.push(`${bref.name} (${bref.port_type})`)
            }
          })
        }
        
        return connection
      })
      this.statusSubscribe(this.connections, 'CONNECTIONS')
      console.log('CONNECTIONS', 'prepareRows', 'table', this.table)
      console.log('CONNECTIONS', 'prepareRows', 'this.connections', this.connections)
    },

    async statusSubscribe(arr: any[], group: string): Promise<void> {
      try {
        this.$store.dispatch('measuresSubscribeInit', {
          name: 'addStatus',
          group: 'CONNECTIONS',
          listener: 'status'
        })
        
        if (arr.length) {
          arr.forEach(item => {
            if (item.$id) {
              this.$store.dispatch('addStatusKey', item)
            }
          })
          await this.$bridge.subscribe(arr.map(obj => obj.$id))
        }
      } catch (error) {
        console.error('CONNECTIONS', 'statusSubscribe', 'error', error)
      }
    },

    subscribeHandler(e: { $id?: string; [key: string]: any }): void {
      if (e.$id) {
        this.$store.dispatch('addStatus', e)
      }
    },

    statusUnsubscribe(): void {
      this.$store.dispatch('measuresSubscribeClose', {
        handler: this.subscribeHandler,
        group: 'CONNECTIONS',
        listener: 'status'
      })
    },

    onAdd(): void {
      console.log('CONNECTIONS', 'onAdd')
      this.$set(this.dialog, 'addMode', true)
      this.$set(this.dialog, 'open', true)
    },

    onSelect(val: ConnectionItem): void {
      console.log('CONNECTIONS', 'onSelect', 'val', val)
      if (val) {
        this.$set(this.dialog, 'data', val)
        this.$set(this.dialog, 'addMode', false)
        this.$set(this.dialog, 'open', true)
      }
    },

    onDialogClose(): void {
      console.log('CONNECTIONS', 'onDialogClose')
      this.$set(this.dialog, 'data', null)
      this.$set(this.dialog, 'addMode', false)
      this.$set(this.dialog, 'open', false)
    },

    async onUpdate(val: ConnectionItem): Promise<void> {
      console.log('CONNECTIONS', 'onUpdate', 'val', val)
      if (!val?.$id) return
      
      try {
        const $obj = await this.$bridge.getObjectById(val.$id)
        console.log('CONNECTIONS', 'onUpdate', 'updated $obj', $obj)
        const c = await $obj.update(val)
        
        if (c) {
          await this.$store.dispatch('updateObject', { $id: c.$id })
          console.log('CONNECTIONS', 'onUpdate', 'updated update $obj', c)
          this.$bridge.litePolling(c.$id)
          this.setup()
        } else {
          this.$dialog.notify.error(this.$getTranslate('something wrong with connection'), {
            timeout: 3000
          })
          console.log('CONNECTIONS', 'onUpdate', 'updated update $obj ERROR', c)
        }
      } catch (error) {
        this.$errorHandler(error)
        console.error('CONNECTIONS', 'onUpdate smth wrong', error)
      }
    },

    async onRemove(val: ConnectionItem): Promise<void> {
      console.log('CONNECTIONS', 'onRemove', 'val', val)
      
      try {
        const obj$ = await this.$bridge.getObjectById(val.$id)
        if (obj$) {
          const d = await obj$.delete()
          if (d) {
            this.onDialogClose()
            this.setup()
            this.$dialog.notify.success('Соединение удалено', { timeout: 5000 })
            this.setup()
          }
        }
      } catch (error) {
        console.error('CONNECTIONS', 'onRemove smth wrong', error)
        this.$errorHandler(error)
      }
    },

    reset(): void {
      this.dialog = {
        open: false,
        addMode: false,
        data: null,
      }
    },
  },
})
</script>

<style lang="css" scoped>
</style>
